import React, { useState } from "react";
import { Modal, Input } from "antd";

import useUpdate from "hooks/useUpdate";
import CustomComponents from "../CustomComments";
import upperCaseSentences from "helpers/upperCaseSentences";

const EditCommentModal = ({
  handleClose,
  refetch,
  issue_comment_id,
  default_content,
}) => {
  const [content, setContent] = useState(default_content);

  const { is_saving, updateAsync } = useUpdate({
    path: `/issue_comments/${issue_comment_id}`,
    onSuccess: refetch,
  });

  const handleOk = async () => {
    try {
      await updateAsync({
        content,
      });
      handleClose();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal
      maskClosable={false}
      width={700}
      title="Aktualizuj komentarz"
      open={true}
      onOk={handleOk}
      onCancel={handleClose}
      cancelText="Anuluj"
      okText="Zapisz"
      okButtonProps={{
        disabled: !content || is_saving,
        loading: is_saving,
      }}
    >
      <Input.TextArea
        style={{ marginBottom: 20 }}
        value={content}
        onChange={({ target: { value } }) =>
          setContent(upperCaseSentences(value))
        }
        rows={7}
        maxLength={400}
        showCount={true}
      />
      <CustomComponents
        content={content}
        setContent={setContent}
      />
    </Modal>
  );
};

export default EditCommentModal;
